import {PieChart} from 'react-minimal-pie-chart';
import './Score.scss';

const Score = function(props) {
	let scoreColor;
	switch (true) {
		case props.score >= 60 && props.score < 80:
			scoreColor = '#f88507';
			break;
		case props.score >= 80:
			scoreColor = '#039669';
			break;
		default:
			scoreColor = '#E11D48';
	}

	return (
		<div className="score-panel">
			<div className="score">
			<PieChart
				data={[
					{title: window?.t?.SCORE, value: props.score, color: scoreColor},
				]}
				startAngle={270}
				lineWidth="16"
				totalValue="100"
				rounded={true}
				animate={true}
				background="#dadada"

			/>
			<p className="score-label">{props.score}/100</p>
			</div>
		</div>
	)
}
export default Score;